module.exports = __webpack_public_path__ + "6a773e3f0f98adc273eb2770ca5ae121.png";